import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {RiskDictionary} from "../../../../shared/interface/risk-dictionary";
import {RiskDictionaryService} from "../../../../shared/services/risk-dictionary.service";
import {RiskDictionaryRisk} from "../../../../shared/interface/risk-dictionary-risk";
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-risk-dict-group-form',
  templateUrl: './risk-dict-group-form.component.html',
  styleUrls: ['./risk-dict-group-form.component.scss']
})
export class RiskDictGroupFormComponent implements OnInit, OnDestroy {
  @Input() riskDictionary: RiskDictionary;
  @Output() closeModification: EventEmitter<boolean> = new EventEmitter<boolean>();

  formGroupsValid = false;
  formGroups: FormArray;
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private riskDictionaryService: RiskDictionaryService,
    private snack: MatSnackBar,
  ) {
    this.formGroups = fb.array([]);
  }

  ngOnInit(): void {
    this.formGroups.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formGroupsValid = this.formGroups.valid);

    this.riskDictionary.risks.forEach((risk: RiskDictionaryRisk) => {
      this.addRisk(risk);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.closeModification.emit(false);
  }

  addRisk(initialValue?: RiskDictionaryRisk): void {
    const formGroup = this.fb.group({
      uuid: this.fb.control(initialValue ? initialValue.uuid : uuidv4()),
      name: this.fb.control(initialValue ? initialValue.name
        ?.split('; ')
        ?.filter((val: string) => val.trim().length > 0) : []),
      groupName: this.fb.control(initialValue ? initialValue.groupName : ''),
      rates: this.fb.control(initialValue ? initialValue.ratesArray : [], []),
      internalRisk: this.fb.control(initialValue ? initialValue.internalRisk?.id : ''),
    });

    this.formGroups.push(formGroup);
  }

  removeRisk(i: number): void {
    this.formGroups.removeAt(i);
  }

  save(): void {
    this.processingRequest = true;

    this.riskDictionaryService.configure(this.riskDictionary.uuid, {risks: this.formGroups.value})
      .subscribe({
        next: () => {
          this.processingRequest = false;
          this.snack.open('Konfiguracja została pomyślnie zapisana', '', {duration: 2000});
          this.closeModification.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.processingRequest = false;
          this.snack.open('Przy zapisywaniu konfiguracji wystąpił błąd', error.status.toString(), {duration: 2000});
        }
      });
  }

}
